import { useState } from "react";
import styled from "@emotion/styled";

import useParagonUser from "lib/hooks/api/integrations/useParagonUser";
import { paragon } from "lib/integrations/paragon";
import CMSConnectionCard from "./CMSConnectionCard";
import ProcessingModal from "./ProcessingModal";
import { ProviderType } from "./types";

const ALLOWED_INTEGRATIONS: ProviderType[] = ["googledrive", "sharepoint"];

export default function IntegrationsCatalog() {
  const { user } = useParagonUser();

  const [syncingProvider, setSyncingProvider] = useState<ProviderType | null>(null);

  return (
    <>
      <ProcessingModal
        open={syncingProvider !== null}
        source={syncingProvider}
        onOpenChange={(open) => {
          if (!open) setSyncingProvider(null);
        }}
      />
      <Container>
        {paragon
          .getIntegrationMetadata()
          .filter((integration) => ALLOWED_INTEGRATIONS.includes(integration.type as ProviderType))
          .map((integration) => {
            const integrationEnabled = !!user?.integrations?.[integration.type]?.enabled;
            return (
              <CMSConnectionCard
                key={integration.type}
                setSyncingProvider={setSyncingProvider}
                integration={{
                  ...integration,
                  type: integration.type as ProviderType,
                  icon: integration.icon,
                  isEnabled: integrationEnabled,
                }}
              />
            );
          })}
      </Container>
    </>
  );
}

const Container = styled.div({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(285px, min-content))",
  marginBottom: 48,
  gridGap: 24,
  alignItems: "end",
});
